import gql from 'graphql-tag';

const query = gql`
  query Majors {
    majors
  }
`;

export default query;
